import React from "react";
import BankAcquirerGenericSkeleton from "./BankAcquirerGenericSkeleton";

function BankAcquirerDetailSkeleton() {
  return (
    <>
      <BankAcquirerGenericSkeleton />
    </>
  );
}

export default BankAcquirerDetailSkeleton;
